(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gift-band"]) return;
  try {
    
(function(){
function wgbInit(){
  var seed=11; function rnd(){seed=(seed*16807)%2147483647;return (seed-1)/2147483646;}
  function pick(a){return a[Math.floor(rnd()*a.length)];}
  var MOB=window.matchMedia('(max-width: 640px)').matches?0.5:1;
  var IN=['#FFFFFF','#FBF3DF','#F2E2B8','#8E6E36'];

  var cur=window.Shopify&&Shopify.currency, rate=cur?parseFloat(cur.rate):1, code=cur?cur.active:'USD';
  if(cur&&code&&code!=='USD'&&rate&&rate!==1){
    var lang=(document.documentElement.lang||'en').slice(0,2), fmt=null;
    try{fmt=new Intl.NumberFormat(lang,{style:'currency',currency:code,maximumFractionDigits:0,minimumFractionDigits:0});}catch(e){}
    if(fmt){document.querySelectorAll('[data-wgb-cur]').forEach(function(el){
      if(el.dataset.wgbCurDone) return; el.dataset.wgbCurDone='1';
      el.textContent=el.textContent.replace(/(?:US\$|USD\s?|\$)\s?(\d+)(\+?)/g,function(m,n,plus){var v=parseInt(n,10)*rate;v=v>=20?Math.ceil(v/5)*5:Math.ceil(v);return fmt.format(v)+plus;});
    });}
  }
  document.querySelectorAll('[data-wgb-flares]').forEach(function(band){
    if(band.querySelector('.wgb-flare')) return;
    var n=parseInt(band.getAttribute('data-wgb-flares'),10)||30, frag=document.createDocumentFragment();
    for(var i=0;i<Math.round(n*3*MOB);i++){
      var base=pick([1.5,2,2,2.5,3,3,4,5,6]), size=base*2.4+2, el=document.createElement('span'), st=el.style;
      el.className='wgb-flare wgb-flare--tw'; st.width=st.height=size.toFixed(1)+'px';
      st.left=(rnd()*99).toFixed(1)+'%'; st.top=(2+rnd()*94).toFixed(1)+'%'; st.background=pick(IN);
      st.opacity=(0.6+rnd()*0.4).toFixed(2); st.filter='blur('+Math.max(1.2,size*0.2).toFixed(1)+'px)';
      st.animationDelay=(rnd()*5).toFixed(1)+'s'; frag.appendChild(el);
    }
    for(var g=0;g<Math.round(6*MOB);g++){
      var gs=pick([40,56,70,90,110]), ge=document.createElement('span'), gst=ge.style;
      ge.className='wgb-flare'; gst.width=gst.height=gs+'px'; gst.left=(rnd()*95).toFixed(1)+'%';
      gst.top=Math.round(5+rnd()*70)+'%'; gst.background='#FFF6DE';
      gst.opacity=(0.25+rnd()*0.25).toFixed(2); gst.filter='blur('+Math.round(12+rnd()*10)+'px)';
      frag.appendChild(ge);
    }
    band.insertBefore(frag,band.firstChild);
  });
}
wgbInit();
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',wgbInit);}
document.addEventListener('shopify:section:load',wgbInit);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["winter-gift-guide"]) return;
  try {
    
(function(){
function wggInit(){
  document.querySelectorAll('[data-wgg-root]').forEach(function(root){
  if(root.dataset.wggReady) return; root.dataset.wggReady='1';
  var CART=root.getAttribute('data-cart-url')||'/cart', ADD=root.getAttribute('data-cart-add-url')||'/cart/add';

  /* Gold flares: small blurred specks escaping above and below each gold band, plus a few soft glows */
  var seed=7; function rnd(){seed=(seed*16807)%2147483647;return (seed-1)/2147483646;}
  function pick(a){return a[Math.floor(rnd()*a.length)];}
  var MOB=window.matchMedia('(max-width: 640px)').matches?0.5:1;
  var OUT=['#C4A671','#B08D52','#D8C08E','#9C7A3F'], IN=['#FFFFFF','#FBF3DF','#F2E2B8','#8E6E36'];
  root.querySelectorAll('[data-wgg-flares]').forEach(function(band){
    var n=parseInt(band.getAttribute('data-wgg-flares'),10)||26, frag=document.createDocumentFragment();
    for(var i=0;i<Math.round(n*3*MOB);i++){
      var z=pick(['top','in','in','bottom']), base=pick([1.5,2,2,2.5,3,3,4,5,6]), size=base*2.4+2;
      var el=document.createElement('span'); el.className='wgg-flare wgg-flare--tw';
      var st=el.style; st.width=st.height=size.toFixed(1)+'px'; st.left=(rnd()*99).toFixed(1)+'%';
      if(z==='in'){st.top=(2+rnd()*94).toFixed(1)+'%'; st.background=pick(IN);}
      else{st[z]='-'+Math.round(4+rnd()*86)+'px'; st.background=pick(OUT);}
      st.opacity=(0.6+rnd()*0.4).toFixed(2); st.filter='blur('+Math.max(1.2,size*0.2).toFixed(1)+'px)';
      st.animationDelay=(rnd()*5).toFixed(1)+'s';
      frag.appendChild(el);
    }
    for(var g=0;g<Math.round(6*MOB);g++){
      var gs=pick([40,56,70,90,110]), gz=pick(['top','bottom','in']), ge=document.createElement('span');
      ge.className='wgg-flare'; var gst=ge.style; gst.width=gst.height=gs+'px'; gst.left=(rnd()*95).toFixed(1)+'%';
      if(gz==='in'){gst.top=Math.round(10+rnd()*60)+'%'; gst.background='#FFF6DE';}
      else{gst[gz]='-'+Math.round(gs*(0.3+rnd()*0.4))+'px'; gst.background='#D9C190';}
      gst.opacity=(0.25+rnd()*0.25).toFixed(2); gst.filter='blur('+Math.round(12+rnd()*10)+'px)';
      frag.appendChild(ge);
    }
    band.insertBefore(frag,band.firstChild);
  });



  /* Gold flares escaping from the featured product card */
  root.querySelectorAll('[data-wgg-sparkle]').forEach(function(card){
    if(card.querySelector('.wgg-flare')) return;
    var frag=document.createDocumentFragment(), sides=['top','bottom','left','right'];
    for(var i=0;i<Math.round(46*MOB);i++){
      var side=sides[i%4], base=pick([1.5,2,2,2.5,3,3,4,5]), size=base*2.4+2;
      var el=document.createElement('span'); el.className='wgg-flare wgg-flare--tw'; var st=el.style;
      st.width=st.height=size.toFixed(1)+'px';
      var along=(rnd()*100).toFixed(1)+'%', out='-'+Math.round(3+rnd()*48)+'px';
      if(side==='top'||side==='bottom'){st.left=along; st[side]=out;} else {st.top=along; st[side]=out;}
      st.background=pick(OUT); st.opacity=(0.55+rnd()*0.45).toFixed(2);
      st.filter='blur('+Math.max(1.2,size*0.2).toFixed(1)+'px)'; st.animationDelay=(rnd()*5).toFixed(1)+'s';
      frag.appendChild(el);
    }
    for(var g=0;g<4;g++){
      var gs=pick([40,56,70]), ge=document.createElement('span'), gst=ge.style, gside=sides[g];
      ge.className='wgg-flare'; gst.width=gst.height=gs+'px';
      gst[(gside==='top'||gside==='bottom')?'left':'top']=Math.round(10+rnd()*70)+'%';
      gst[gside]='-'+Math.round(gs*0.5)+'px'; gst.background='#E3CF9F';
      gst.opacity=(0.3+rnd()*0.2).toFixed(2); gst.filter='blur('+Math.round(12+rnd()*8)+'px)';
      frag.appendChild(ge);
    }
    card.insertBefore(frag,card.firstChild);
  });

  /* Hand-written US$ amounts (tiles, buttons, badges) follow the visitor's currency */
  (function(){
    var cur=window.Shopify&&Shopify.currency, rate=cur?parseFloat(cur.rate):1, code=cur?cur.active:'USD';
    if(!cur||!code||code==='USD'||!rate||rate===1) return;
    var lang=(document.documentElement.lang||'en').slice(0,2), fmt;
    try{fmt=new Intl.NumberFormat(lang,{style:'currency',currency:code,maximumFractionDigits:0,minimumFractionDigits:0});}catch(e){return;}
    function nice(usd){var v=usd*rate; return v>=20?Math.ceil(v/5)*5:Math.ceil(v);}
    root.querySelectorAll('[data-wgg-cur]').forEach(function(el){
      if(el.dataset.wggCurDone) return; el.dataset.wggCurDone='1';
      el.textContent=el.textContent.replace(/(?:US\$|USD\s?|\$)\s?(\d+)(\+?)/g,function(m,n,plus){return fmt.format(nice(parseInt(n,10)))+plus;});
    });
  })();

  /* Mobile: trust bar becomes an auto-playing carousel, timed to reading speed */
  root.querySelectorAll('[data-wgg-trust],[data-wgg-auto]').forEach(function(track){
    var items=[].slice.call(track.children), dotsWrap=track.parentNode.querySelector('[data-wgg-trust-dots],[data-wgg-auto-dots]');
    if(!dotsWrap||items.length<2) return;
    var dots=[].slice.call(dotsWrap.children), mq=window.matchMedia('(max-width: 640px)');
    var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches, idx=0, timer=null, pausedUntil=0;
    function readTime(el){var w=(el.textContent||'').trim().split(/\s+/).length; return Math.max(3500, 1500 + w/3.3*1000);}
    function setActive(i){idx=i; dots.forEach(function(d,k){d.classList.toggle('is-active',k===i);});}
    function go(i){track.scrollTo({left:i*track.clientWidth,behavior:'smooth'}); setActive(i);}
    function schedule(){clearTimeout(timer); if(!mq.matches||reduce) return;
      timer=setTimeout(function(){ if(Date.now()<pausedUntil){schedule();return;} go((idx+1)%items.length); schedule(); }, readTime(items[idx]));}
    track.addEventListener('scroll',function(){ if(!mq.matches) return;
      var i=Math.round(track.scrollLeft/track.clientWidth); if(i!==idx&&items[i]){setActive(i);} },{passive:true});
    ['touchstart','pointerdown'].forEach(function(ev){track.addEventListener(ev,function(){pausedUntil=Date.now()+8000;},{passive:true});});
    dots.forEach(function(d,k){d.addEventListener('click',function(){pausedUntil=Date.now()+8000; go(k); schedule();});});
    if(mq.addEventListener){mq.addEventListener('change',schedule);}
    schedule();
  });
  root.querySelectorAll('[data-wgg-car]').forEach(function(car){
    var track=car.querySelector('[data-wgg-track]'), prev=car.querySelector('[data-wgg-prev]'), next=car.querySelector('[data-wgg-next]');
    function step(){var c=track.querySelector('.wgg-slide');return c?c.getBoundingClientRect().width+24:track.clientWidth;}
    function sync(){var max=track.scrollWidth-track.clientWidth-2;prev.hidden=track.scrollLeft<=2;next.hidden=track.scrollLeft>=max;}
    prev.addEventListener('click',function(){track.scrollBy({left:-step(),behavior:'smooth'});});
    next.addEventListener('click',function(){track.scrollBy({left:step(),behavior:'smooth'});});
    track.addEventListener('scroll',sync,{passive:true}); window.addEventListener('resize',sync); sync();
  });

  /* Add to cart without leaving the page; falls back to the normal form post if anything fails */
  var toast=root.querySelector('[data-wgg-toast]'), msg=root.querySelector('[data-wgg-toast-msg]'), timer;
  function showToast(t){msg.textContent=t; toast.classList.add('is-open'); clearTimeout(timer); timer=setTimeout(function(){toast.classList.remove('is-open');},4000);}
  function updateCount(){
    fetch(CART+'.js',{credentials:'same-origin'}).then(function(r){return r.json();}).then(function(cart){
      document.querySelectorAll('[data-cart-count]').forEach(function(el){el.textContent=cart.item_count;});
      document.querySelectorAll('[data-cart-count-bubble]').forEach(function(el){el.classList.remove('hide');});
    }).catch(function(){});
  }
  root.querySelectorAll('[data-wgg-add]').forEach(function(form){
    form.addEventListener('submit',function(e){
      if(!window.fetch) return;
      e.preventDefault();
      var btn=form.querySelector('button'), label=btn.textContent; btn.disabled=true; btn.textContent=root.getAttribute('data-t-adding')||'Adding…';
      fetch(ADD+'.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({items:[{id:parseInt(form.querySelector('[name=id]').value,10),quantity:1}]})})
      .then(function(r){ if(!r.ok) return r.json().then(function(j){throw new Error(j.description||'Could not add this item');}); return r.json(); })
      .then(function(){ btn.textContent=root.getAttribute('data-t-added')||'Added'; showToast(root.getAttribute('data-t-added-cart')||'Added to cart'); updateCount(); setTimeout(function(){btn.textContent=label;btn.disabled=false;},1800); })
      .catch(function(err){ btn.textContent=label; btn.disabled=false; showToast(err.message); });
    });
  });
});
}
wggInit();
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',wggInit);}
document.addEventListener('shopify:section:load',wggInit);
})();

  } catch(e) { console.error(e); }
})();
})();
